"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var createIcon_1 = __importDefault(require("../createIcon"));
var BrandIconAgent = function (props) {
    return (react_1.default.createElement(createIcon_1.default, __assign({ role: "img", ariaLabel: "Agent" }, props),
        react_1.default.createElement("title", null, "Agent"),
        react_1.default.createElement("path", { d: "M8.646 65.325c0-28.382 23.015-51.396 51.397-51.396 28.382 0 51.386 23.014 51.386 51.396", fill: "#000" }),
        react_1.default.createElement("path", { d: "M60.032 105.3c22.078 0 39.975-17.897 39.975-39.975 0-22.078-17.897-39.975-39.975-39.975-22.077 0-39.975 17.898-39.975 39.975 0 22.078 17.898 39.975 39.975 39.975z", fill: "#FF6E00" }),
        react_1.default.createElement("path", { d: "M60.032 25.35c22.072 0 39.975 17.893 39.975 39.975 0 22.072-17.893 39.975-39.975 39.975", fill: "#D44513" }),
        react_1.default.createElement("path", { d: "M111.364 42.482H92.893v39.975h18.471V42.482z", fill: "#007562" }),
        react_1.default.createElement("path", { d: "M111.364 42.482H92.893v39.975h18.471V42.482zM27.043 42.482H8.57v39.975h18.472V42.482z", fill: "#007562" }),
        react_1.default.createElement("path", { d: "M60.257 73.318H8.571v9.14h51.686v-9.14z", fill: "#000" })));
};
exports.default = BrandIconAgent;
